import React from "react";
import { createPortal } from "react-dom";
import { formatRupiah } from "../../../../../helper/formatNumber";
import { formatDateTransactionDetail } from "../../../../../helper/formatDate";

const ModalDetailClinicSales = ({
  isShowModal,
  onCloseModal,
  clinicTransaction,
}) => {
  return createPortal(
    isShowModal && (
      <div className="modal-product-container">
        <div className="modal-product-content">
          <header className="modal-product-header">
            <h2 className="modal-product-header-title">Detail Transaksi</h2>
            <button
              className="modal-header-close-button"
              onClick={() => onCloseModal()}
            >
              &times;
            </button>
          </header>
          <main className="modal-product-main">
            <p style={{ margin: 0, padding: 0 }}>
              Tanggal Transaksi:{" "}
              {formatDateTransactionDetail(
                clinicTransaction.medical_transaction_date
              )}
            </p>
            <p style={{ margin: 0, padding: 0 }}>
              Pasien: {clinicTransaction.patient_name}
            </p>
            <p style={{ margin: 0, padding: 0 }}>
              Dokter: {clinicTransaction.doctor_name}
            </p>
            <div className="product-table-container">
              <table className="product-table">
                <thead>
                  <tr>
                    <th width="50px">No</th>
                    <th>Tindakan</th>
                    <th>Total Transaksi</th>
                  </tr>
                </thead>
                <tbody>
                  {clinicTransaction.medical_transaction_data.map(
                    (transaction, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{transaction.medical_transaction_name}</td>
                        <td>
                          {formatRupiah(
                            transaction.medical_transaction_service_fee
                          )}
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          </main>
          <footer className="modal-product-footer">
            <button
              className="modal-close-button"
              onClick={() => onCloseModal()}
            >
              Tutup
            </button>
          </footer>
        </div>
      </div>
    ),
    document.getElementById("modal")
  );
};

export default ModalDetailClinicSales;
